<script>
    import _ from 'lodash'
    import moment from 'moment'
    import EventBus from '@/components/EventBus'
    import OrgService from '@/request/user/org'
    import RoomService from '@/request/aims/room'
    import OperationService from '@/request/aims/operation'
    import Vue from 'vue'
    import md5 from 'js-md5'
    import VueFullcalendar from '@/components/VueFullcalendar'
    Vue.use(VueFullcalendar)
    export default {
        name: 'AimsArrangeList',
        props: {
            hid: {
                type: Number,
                default: 0
            },
            height: {
                type: Number,
                default: 650
            },
            currentDate: {
                type: Number,
                default: moment().startOf('day').valueOf()
            }
        },
        data () {
            return {
                oids: [],
                rooms: [],
                calendarOptions: {
                    defaultDate: moment(),
                    deleteDroppableElement: true,
                    contentHeight: this.height,
                    locale: 'zh-cn',
                    editable: true,
                    selectable: false,
                    allDaySlot: false,
                    defaultView: 'agendaDay',
                    eventResourceField: 'resourceId',
                    slotLabelFormat: 'HH:mm',
                    timeFormat: 'HH:mm',
                    displayEventTime: true,
                    displayEventEnd: false,
                    minTime: '08:00:00',
                    maxTime: '22:00:00',
                    // slotDuration: '00:15',
                    header: false
                },
                calendarResources: [],
                events: [],
                operations: [],
                arrageStore: {},
                operationLoading: false,
                waitSave: {},
                waitUpdateEvent: {},
                saveDebounced: _.debounce(this.saveWaitOperations, 1000, {'maxWait': 2000}),
            }
        },
        computed: {},
        created: function () {
            this.listOids()
            this.changeDate()
            EventBus.$on('websocket-message', this.handleWebsocket)
        },
        mounted: function () {},
        beforeDestroy () {
            this.arrageStore = {}
            EventBus.$off('websocket-message', this.handleWebsocket)
        },
        watch: {
            'hid': function () {
                this.listOids()
            },
            'oids': function () {
                this.listRoom()
                this.listOperation()
            },
            'currentDate': function () {
                this.changeDate()
                this.listOperation()
            }
        },
        methods: {
            changeDate () {
                if (!this.currentDate) {
                    this.currentDate = moment().startOf('day').valueOf()
                    return
                }
                this.calendarOptions.defaultDate = moment(this.currentDate)
                let calendar = this.$refs.calendar ? this.$refs.calendar.getInstance() : null
                if (calendar) {
                    calendar.gotoDate(moment(this.currentDate))
                }
            },
            listOids () {
                let self = this
                if (!self.hid) {
                    self.oids = []
                    return
                }
                OrgService.listOrgId({
                    pids: self.hid,
                    descendant: 1
                }).then(res => {
                    self.oids = res.result || []
                })
            },
            listRoom () {
                let self = this
                self.rooms = []
                self.calendarResources = []
                if (!self.hid) {
                    return
                }
                RoomService.list({
                    hids: self.hid
                }).then(res => {
                    let data = res.result || []
                    let resources = []
                    // self.rooms = _.sortBy(data, ['name'])
                    self.rooms = _.clone(data)
                    if (_.isEmpty(self.rooms)) {
                        return
                    }
                    _.forEach(self.rooms, value => {
                        resources.push({
                            id: value.id,
                            title: value.name
                        })
                    })
                    self.calendarResources = _.clone(resources)
                })
            },
            listOperation () {
                let self = this
                self.operations = []
                self.events = []
                if (_.isEmpty(self.oids) || !self.currentDate) {
                    return
                }
                self.operationLoading = true
                let poperation = OperationService.list({
                    start: self.currentDate,
                    end: moment(self.currentDate).endOf('day').valueOf(),
                    orgs: _.join(self.oids),
                    status: '4,5'
                })
                poperation.then(res => {
                    let data = res.result || []
                    self.operations = _.sortBy(data, ['arrangedStartTime', 'roomName'])
                    if (_.isEmpty(data)) {
                        return
                    }
                    _.forEach(data, operation => {
                        if (operation.currentState !== 4 && operation.currentState !== 5) {
                            return
                        }
                        if (operation.arrangedStartTime < this.currentDate || operation.arrangedStartTime > moment(this.currentDate).endOf('day').valueOf()) {
                            return
                        }
                        self.updateEvent(operation)
                    })
                })
                poperation.finally(() => {
                    self.operationLoading = false
                })
            },
            updateEvent (operation) {
                if (!operation) {
                    return
                }
                let self = this
                if (operation.currentState !== 4 && operation.currentState !== 5) {
                    this.removeEvent(operation)
                    return
                }
                if (operation.arrangedStartTime < self.currentDate || operation.arrangedStartTime > moment(self.currentDate).endOf('day').valueOf()) {
                    this.removeEvent(operation)
                    return
                }
                const event = this.operationToEvent(operation)
                let index = _.findIndex(self.events, {'id': operation.id})
                if (index < 0) {
                    self.events.push(event)
                    return
                }
                self.$set(self.events, index, _.cloneDeep(event))
                /* if (_.isEmpty(this.operations)) {
                    this.events = []
                    return
                }
                const es = []
                _.forEach(this.operations, operation => {
                    const event = this.operationToEvent(operation)
                    if (!event) return
                    es.push(event)
                })
                this.events = es */
            },
            operationToEvent(operation) {
                if (_.isEmpty(operation)) return null
                const operatorName = operation.operatorName ? operation.operatorName : ''
                const operatingNames = operation.operatingNames ? operation.operatingNames : ''
                const diagnoseNames = operation.diagnoseNames ? operation.diagnoseNames : ''
                const bedid = operation.bedid ? operation.bedid: ''
                const patName = operation.patName ? operation.patName : ''
                const sex = operation.sex && operation.sex === 2 ? "女" : "男"
                const age = operation.age ? operation.age : '';
                let backgroundColor = operation.released <= 0 ? '#60bf60' : '#1890ef'
                let borderColor = operation.released <= 0 ? '#60bf60' : '#1890ef'
                if (operation.currentState === 5) {
                    backgroundColor = '#909399'
                    borderColor = '#909399'
                }
                if (operation.emergency) borderColor = '#FF0000'
                // const passageway = operation.emergency ? '[急诊]' : ''
                const start = moment(operation.arrangedStartTime)
                const event = _.assign({}, operation, {
                    title: bedid + '; ' + patName + ';' + sex + ';' + age + '; ' + operatorName + ';' + operatingNames + ';' + diagnoseNames,
                    durationEditable: true,
                    overlap: false,
                    backgroundColor: backgroundColor,
                    borderColor: borderColor,
                    start: start,
                    end: start.clone().add(operation.duration, 'ms'),
                    resourceId: operation.room,
                })
                return event
            },
            removeEvent (operation) {
                if (!operation) {
                    return
                }
                let events = _.cloneDeep(this.events)
                _.remove(events, event => {
                    return event.id === operation.id
                })
                this.events = _.cloneDeep(events)
            },
            updateOperation (operation) {
                if (!operation) {
                    return
                }
                if (operation.currentState !== 4 && operation.currentState !== 5) {
                    this.removeOperation(operation)
                    return
                }
                if (operation.arrangedStartTime < this.currentDate || operation.arrangedStartTime > moment(this.currentDate).endOf('day').valueOf()) {
                    this.removeOperation(operation)
                    return
                }
                let ops = this.operations
                let index = _.findIndex(ops, {'id': operation.id})
                if (index < 0) {
                    ops.push(operation)
                } else {
                    ops[index] = operation
                }
                this.operations = _.sortBy(ops, ['arrangedStartTime', 'roomName'])
                // this.updateEvent(operation)
            },
            removeOperation (operation) {
                if (!operation) {
                    return
                }
                let operations = _.cloneDeep(this.operations)
                _.remove(operations, item => {
                    return item.id === operation.id
                })
                this.operations = _.cloneDeep(operations)
                this.removeEvent(operation)
            },
            handleDropIn (data, date, jsEvent, ui, resourceId) {
                if (!data) {
                    return
                }
                let self = this
                let ri = -1
                resourceId = parseInt(resourceId)
                if (resourceId) {
                    ri = _.findIndex(self.rooms, {'id': resourceId})
                } else if (data.room) {
                    ri = _.findIndex(self.rooms, {'id': data.room})
                }
                if (ri < 0) {
                    ri = _.random(0, self.rooms.length)
                }
                if (data.currentState !== 3) {
                    let calendar = this.$refs.calendar ? this.$refs.calendar.getInstance() : null
                    if (calendar) {
                        calendar.removeEvents(data.id)
                    }
                    self.$message.error('没有达到排班条件')
                    return
                }
                let operation = _.cloneDeep(data)
                operation.room = self.rooms[ri].id
                operation.roomName = self.rooms[ri].name
                operation.arrangedStartTime = moment(date).valueOf() - 8 * 60 * 60 * 1000
                operation.currentState = 4
                let temp = null
                let tempri = ri
                let success = true
                while (success) {
                    temp = this.checkStart(operation)
                    if (temp) {
                        operation = temp
                        success = false
                        break
                    }
                    if (tempri > ri) {
                        if (tempri < self.rooms.length - 1) {
                            tempri += 1
                            operation.room = self.rooms[tempri].id
                            continue
                        } else {
                            self.$message.error('今天的手术间已排满，请更新手术日期')
                            return
                        }
                    } else {
                        if (tempri > 0) {
                            tempri -= 1
                            operation.room = self.rooms[tempri].id
                            continue
                        } else {
                            tempri = ri + 1
                        }
                    }
                }
                let poperation = OperationService.arrange({
                    id: operation.id,
                    room: operation.room,
                    time: operation.arrangedStartTime
                })
                poperation.then(res => {
                    operation = res.result
                    this.saveStore(operation);
                    this.updateOperation(operation)
                    this.updateEvent(operation)
                    this.$emit('dropIn', operation)
                }, error => {
                    let calendar = this.$refs.calendar ? this.$refs.calendar.getInstance() : null
                    if (calendar) {
                        calendar.removeEvents(data.id)
                    }
                    this.$message.error(error || '手术排班失败，请重试')
                    this.$emit('dropInError', data)
                })
            },
            handleEventDrop (event, delta, revertFunc) {
                let self = this
                let ri = _.findIndex(self.rooms, {'id': parseInt(event.resourceId)})
                let room = null
                if (ri < 0) {
                    self.$message.error('获取手术间信息失败，请重试')
                    return
                }
                room = self.rooms[ri]
                let operation = null
                let oi = _.findIndex(self.operations, {'id': event.id})
                if (oi < 0) {
                    self.$message.error('获取手术信息失败，请重试')
                    return
                }
                let start = event.start
                if (start._isUTC) {
                    start = start.clone().subtract(8, 'h')
                }
                operation = self.operations[oi]
                operation.room = room.id
                operation.roomName = room.name
                operation.arrangedStartTime = start.valueOf()
                operation.currentState = 4
                this.updateEvent(operation)
                this.waitSave[operation.id] = {
                    id: operation.id,
                    room: operation.room,
                    time: operation.arrangedStartTime,
                    revertFunc: revertFunc,
                }
                this.saveDebounced.cancel()
                this.saveDebounced()
            },
            saveWaitOperations() {
                if (_.isEmpty(this.waitSave)) return
                let promiseList = []
                _.forEach(this.waitSave, item => {
                    const revertFunc = item.revertFunc
                    let body = _.clone(item)
                    delete body.type
                    delete body.revertFunc
                    /* if (!this.waitUpdateEvent[body.id]) this.waitUpdateEvent[body.id] = 1
                    else this.waitUpdateEvent[body.id] += 1 */
                    promiseList.push(OperationService.arrange(body).then(res => {
                        // if (this.waitUpdateEvent[body.id]) this.waitUpdateEvent[body.id] -= 1
                        const operation = res.result
                        this.saveStore(operation);
                        this.updateOperation(operation)
                        this.$emit('dropMove', operation)
                        /* if (this.waitUpdateEvent[body.id]) return
                        delete this.waitUpdateEvent[body.id] */
                        // this.updateEvent(operation)
                    }).catch(error => {
                        if (revertFunc) revertFunc()
                        this.$message.error(error || '手术排班失败，请重试')
                    }))
                })
                this.waitSave = {}
                /* if (this.waitUpdateEvent) return
                this.waitUpdateEvent = true
                Promise.all(promiseList).then(() => {
                    this.waitUpdateEvent = false
                    this.updateEvent()
                }) */
            },
            checkStart (operation) {
                if (!operation) {
                    return
                }
                let start = operation.arrangedStartTime
                let end = operation.arrangedStartTime + operation.duration
                let events = _.filter(this.events, ['room', operation.room])
                if (_.isEmpty(events)) {
                    return operation
                }
                events = _.sortBy(events, ['start'])
                let minTime = moment(moment(this.currentDate).format('YYYY-MM-DD') + ' ' + this.calendarOptions.minTime, 'YYYY-MM-DD HH:mm:ss').valueOf()
                let maxTime = moment(moment(this.currentDate).format('YYYY-MM-DD') + ' ' + this.calendarOptions.maxTime, 'YYYY-MM-DD HH:mm:ss').valueOf()
                if (start < minTime) {
                    start = minTime
                    end = minTime + operation.duration
                }
                if (end > maxTime) {
                    end = maxTime
                    start = maxTime - operation.duration
                }
                let enough = []
                for (let i = 0; i < events.length + 1; i++) {
                    let dstart = i > 0 ? events[i - 1].end.valueOf() : minTime
                    let dend = i < events.length ? events[i].start.valueOf() : maxTime
                    if (dend - dstart >= operation.duration) {
                        enough.push(i)
                    }
                }
                if (_.isEmpty(enough)) {
                    return null
                }
                let low = 0
                let high = enough.length - 1
                while (low <= high) {
                    let mid = parseInt((high + low) / 2)
                    let dstart = mid > 0 ? events[mid - 1].end.valueOf() : minTime
                    let dend = mid < events.length ? events[mid].start.valueOf() : maxTime
                    if (start > dstart && end < dend) {
                        break
                    }
                    if (start > dend) {
                        low = mid + 1
                    } else if (end < dstart) {
                        high = mid - 1
                    } else {
                        start = dstart
                        break
                    }
                }
                operation.arrangedStartTime = start
                return operation
            },
            handleClickEvent (calEvent) {
                if (!calEvent) {
                    return
                }
                let index = _.findIndex(this.operations, {'id': calEvent.id})
                if (index < 0) {
                    return
                }
                this.$emit('clickOperation', this.operations[index])
            },
            handleEventReceive (event) {
                console.log(event)
            },
            saveStore(operation) {
                // let sn = operation.room + ':' + operation.arrangedStartTime;
                let sn = this.md5(operation)
                if (!this.arrageStore[operation.id]) {
                    this.arrageStore[operation.id] = []
                }
                if (_.indexOf(this.arrageStore[operation.id], sn) < 0) {
                    this.arrageStore[operation.id].push(sn)
                }
            },
            hasStore(operation) {
                let store = this.arrageStore[operation.id]
                if (store) {
                    // let sn = operation.room + ':' + operation.arrangedStartTime
                    let sn = this.md5(operation)
                    let at = _.lastIndexOf(store, sn);
                    if (store.length === 0) {
                        delete this.arrageStore[operation.id]
                    }
                    if (at >= 0) {
                        return true;
                    }
                }
                return false
            },
            md5(operation) {
                let obj = {
                    sn: operation.sn,
                    arrangedStartTime: operation.arrangedStartTime,
                    duration: operation.duration,
                    room: operation.room,
                    currentState: operation.currentState
                }
                return md5(JSON.stringify(obj))
            },
            handleWebsocket (data) {
                if (!data) {
                    return
                }
                if (_.isString(data)) {
                    data = JSON.parse(data)
                }
                if (!data.source || data.source !== 'eber-system-aims') {
                    return
                }
                let operation = data.message
                if (this.hasStore(operation)) {
                    return;
                }
                if (data.topic === 'aims-operation-save') {
                    this.updateOperation(operation)
                    this.updateEvent(operation)
                } else if (data.topic === 'aims-operation-delete') {
                    this.removeOperation(operation)
                    this.removeEvent(operation)
                }
            },
            cancleArrange(operation) {
                this.saveStore(operation)
                this.updateOperation(operation)
                this.updateEvent(operation)
            }
        }
    }
</script>

<template>
    <vue-fullcalendar
            v-loading="operationLoading"
            ref="calendar"
            class="calendar"
            :options="calendarOptions"
            :resources="calendarResources"
            :events="events"
            @drop="handleDropIn"
            @eventDrop="handleEventDrop"
            @eventClick="handleClickEvent">
    </vue-fullcalendar>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
